import * as types from '../../mutation-types';

/**
 * Set all items in store
 * @param {function} commit
 * @param {IPaymentMethodListItem[]} items
 */
export function setItems({ commit }, { items }) {
    commit(types.SET_PAYMENTMETHOD_ITEMS, { items });
}

/**
 * Set the overlay reference of an item
 * @param {function} commit
 * @param {number} item
 * @param {string} overlayId
 */
export function setItemOverlayRef({ commit }, { hash, overlayId }) {
    commit(types.SET_PAYMENTMETHOD_ITEM_OVERLAYREF, { hash: hash, overlayId: overlayId });
}
